import { Row, RowProps } from '@igooods/ui-kit';
import { DefaultTheme } from 'styled-components';

export interface IRow extends Omit<RowProps, 'theme'> {
  theme: DefaultTheme;
}

export default Row;
